import { FactionType } from "~/business";
import { Colors } from "~/jsx/theme";
import { XTypography } from "./XTypography";

export const XCardFactionName = ({ faction }: { faction: FactionType }) => {
  return (
    <div
      key={faction}
      style={{
        backgroundColor: Colors.faction[faction].light,
        padding: "1px 10px 1px 5px",
        display: "inline-block",
      }}
    >
      <XTypography typographyStyle={{ color: "white" }}>{faction}</XTypography>
    </div>
  );
};
